import { sortBy, filter } from 'lodash';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
export default ({ widget, stepProjects, oneParentIsSupervisor, parentWidget }) => [
    {
        label: 'Name',
        key: 'name',
        type: 'string',
        elementProps: {
            isRequired: true,
            placeholder: 'Widget name',
        },
    },
    {
        label: parentWidget && !(widget === null || widget === void 0 ? void 0 : widget.config.hasOwnProperty('assetType'))
            ? `Asset type (inherited from ${parentWidget.name})`
            : 'Asset type',
        key: 'assetType',
        type: 'select',
        elementProps: (data, setData) => ({
            onChange: (option) => {
                setData(Object.assign(Object.assign({}, data), { assetType: option.value, steps: [] }));
            },
            options: [
                { label: 'Shots', value: 'sh' },
                { label: 'Models', value: 'mo' },
                { label: 'None', value: undefined },
            ],
            style: { width: '100%' },
            placeholder: 'Select an asset type',
        }),
    },
    {
        label: parentWidget && !widget.config.hasOwnProperty('steps') ? `Steps (inherited from ${parentWidget.name})` : 'Steps',
        key: 'steps',
        type: 'muiautocomplete',
        elementProps: (data) => {
            return {
                disabled: !data.assetType,
                options: sortBy(filter(stepProjects, (step) => step.assetType === data.assetType), ['name']).map((step) => ({
                    label: step.name,
                    value: step.id,
                })),
                multiple: true,
                style: { width: '100%' },
            };
        },
    },
    {
        label: `Limited access ${widget.widgetType === WIDGET_TYPES.CONTAINER ? 'group' : 'widget'}`,
        key: 'isSupervisor',
        type: 'checkbox',
        elementProps: {
            disabled: oneParentIsSupervisor,
        },
    },
];
